var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotebook = function SvgNotebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.19651C11 4.30471 10.4117 3.50896 9.53792 3.33065C6.91656 2.7957 3.95942 2.79515 1.50386 4.19832C1.19229 4.37637 1 4.70771 1 5.06657V20.5666C1 20.9027 1.16888 21.2164 1.44951 21.4014C1.73014 21.5865 2.08496 21.6181 2.39392 21.4857C5.00099 20.3684 8.24568 21.0051 11 22.1549V5.19651Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22.1549C15.7543 21.0051 18.999 20.3684 21.6061 21.4857C21.915 21.6182 22.2699 21.5865 22.5505 21.4014C22.8311 21.2164 23 20.9027 23 20.5666V5.06658C23 4.70772 22.8077 4.37638 22.4961 4.19833C20.0406 2.79516 17.0834 2.79571 14.4621 3.33065C13.5883 3.50897 13 4.30471 13 5.19652V22.1549Z",
    fill: "currentColor"
  })));
};
export default SvgNotebook;